import React from "react";
import { GenericTable } from "@shared/components/GenericTable";
import { TableColumn } from "@shared/types/table";

interface WorkOrdersTabProps {
  workOrdersData: any[];
  workOrdersColumns: TableColumn<any>[];
}

export function WorkOrdersTab({ workOrdersData, workOrdersColumns }: WorkOrdersTabProps) {
  return (
    <div className="space-y-4">
      <div className="border border-gray-150 rounded-xl overflow-hidden">
        <GenericTable
          columns={workOrdersColumns}
          data={workOrdersData}
          rowKey="id"
        />
      </div>
      <div className="text-xs text-gray-400 font-medium mt-2">
        {workOrdersData.length} work order(s) raised
      </div>
    </div>
  );
}
